export default {
  newPassword: 'Nueva contraseña',
  passwordRegex: 'Tiene que tener: mínimo 6 caracteres, al menos 1 mayúscula, 1 minúscula y 1 número (0~9).',
  password: 'Contraseña',
  passwordPlaceHolder: 'Escribe una Contraseña',
  repeatPassword: 'Repetir contraseña',
  repeatPasswordPlaceHolder: 'Repite la contraseña',
  create: 'Crear',
  invalidPasswordFormat: 'Formato de contraseña invalido',
  passwordsDontMatch: 'Las contraseñas no coinciden. Prueba de nuevo',
  newPasswordCreated: '¡Nueva contraseña creada!',
  newPasswordCreatedText: 'Tu contraseña se ha actualizado, regresa a Kimple para ingresar con tu nueva contraseña.',
  returnToKimple: 'Regresar a Kimple'
}

export const en = {
  newPassword: 'New password',
  passwordRegex: 'The password must have: a minimum of 6 characters,at least one character in uppercase,one character in lowercase and one number (0-9)',
  password: 'password',
  passwordPlaceHolder: 'Write a Password',
  repeatPassword: 'Repeat password',
  repeatPasswordPlaceHolder: 'Repeat the password',
  create: 'Create',
  invalidPasswordFormat: 'Invalid password format',
  passwordsDontMatch: 'Passwords don\'t match. Try again',
  newPasswordCreated: 'New password created!',
  newPasswordCreatedText: 'Your password has been updated, return to Kimple to log in with your new password.',
  returnToKimple: 'Return to Kimple'
}

export const ca = {
  newPassword: 'Paraula de pas nova',
  passwordRegex: 'Ha de tenir: com a mínim 6 caràcters, d\'entre els quals 1 majúscula, 1 minúscula i 1 número (0~9).',
  password: 'Paraula de pas',
  passwordPlaceHolder: 'Escriu una Paraula de pas',
  repeatPassword: 'Repeteix la paraula de pa',
  repeatPasswordPlaceHolder: 'Repeteix la paraula de pa',
  create: 'Crea',
  invalidPasswordFormat: 'Format invàlid per a la paraula de pas',
  passwordsDontMatch: 'Les paraules de pas no coincideixen. Prova un altre cop',
  newPasswordCreated: 'S\'ha creat una paraula de pas nova!',
  newPasswordCreatedText: 'La teva paraula de pas s\'ha actualitzat, torna a Kimple per entrar amb la teva paraula de pas nova.',
  returnToKimple: 'Torna a Kimple'
}
